const HELP_TOPICS = [
  // --- PORTAL ---
  {
    id: 'module-navigation',
    section: 'portal',
    title: 'Modüllere nasıl geçilir?',
    keywords: ['modul', 'modül', 'portal', 'anasayfa', 'menu', 'menü', 'gecis', 'geçiş', 'nereden', 'hangi ekran'],
    steps: [
      'Giriş yaptıktan sonra Portal ekranı açılır.',
      'Yetkiniz olan modül kartına tıklayın (Muhasebe, Satış, Siparişler vb.).',
      'Modül içinde sol menüden alt bölümlere geçebilirsiniz.',
      'Portal\'a dönmek için sol menüdeki logo veya modül seçim alanını kullanın.',
    ],
    hint: 'Admin kullanıcılar tüm modülleri görür; diğer roller yalnızca yetkili oldukları modülleri görür.',
  },
  {
    id: 'license-purchase',
    section: 'portal',
    title: 'Lisans nasıl satın alınır?',
    keywords: ['lisans', 'satın al', 'satin al', 'paket', 'odeme', 'ödeme', 'demo', 'ucret', 'ücret', '1 yil', '3 yil', '5 yil'],
    steps: [
      'Portal ekranında Lisans Satın Al butonuna basın.',
      '1 Yıl, 3 Yıl veya 5 Yıl paketlerinden birini seçin.',
      'Paketi Seç adımından sonra ödeme yöntemini belirleyin.',
      'Kredi Kartı, Banka Kartı veya Havale/EFT seçeneklerinden biri ile devam edin.',
    ],
    hint: 'Demo kullanıcısı da portal ekranından lisans akışını görebilir; satın alma ekibi sizinle iletişime geçer.',
  },
  {
    id: 'demo-limit',
    section: 'portal',
    title: 'Demo sürüm sınırı nedir?',
    keywords: ['demo', 'sinir', 'sınır', '5 islem', '5 işlem', 'ucretsiz', 'ücretsiz', 'deneme'],
    steps: [
      'Demo hesapta her modül için en fazla 5 yeni kayıt oluşturabilirsiniz.',
      'Sınır aşıldığında sistem uyarı verir ve kayıt engellenir.',
      'Sınırsız kullanım için portal ekranından lisans satın alma adımlarını başlatın.',
    ],
    hint: 'Demo giriş: firma kodu demo, kullanıcı admin, şifre admin123.',
  },

  // --- DASHBOARD ---
  {
    id: 'dashboard-overview',
    section: 'dashboard',
    title: 'Ana panel ne gösterir?',
    keywords: ['panel', 'dashboard', 'anasayfa', 'ozet', 'özet', 'istatistik', 'grafik', 'kpi'],
    steps: [
      'Anasayfa modülünde günlük satış, gider, bekleyen sipariş ve üretim özetleri görünür.',
      'Admin kullanıcılar satış/gider trend grafiklerini ve alacak toplamlarını görür.',
      'Son Aktiviteler, En Çok Satan Ürünler ve Stok Uyarısı bölümlerini inceleyin.',
    ],
    hint: 'Bu ekran salt okunurdur; işlem yapmak için ilgili modüle geçmeniz gerekir.',
  },
  {
    id: 'notifications-read',
    section: 'dashboard',
    title: 'Bildirimler nasıl okunur?',
    keywords: ['bildirim', 'zil', 'notification', 'okunmamis', 'okunmamış', 'uyari', 'uyarı'],
    steps: [
      'Sağ üstteki zil ikonuna tıklayın.',
      'Bildirim listesinden ilgili kaydı seçin.',
      'Mesajı okundu işaretleyebilir veya önemli olarak işaretleyebilirsiniz.',
      'Bildirimde link varsa ilgili modül ekranına yönlendirilirsiniz.',
    ],
    hint: 'Okunmamış bildirim sayısı zil ikonunun yanında gösterilir.',
  },

  // --- MUHASEBE ---
  {
    id: 'invoice-create',
    section: 'accounting',
    title: 'Fatura nasıl oluşturulur?',
    keywords: ['fatura', 'e-arsiv', 'e-arşiv', 'earsiv', 'muhasebe', 'kalem', 'olustur', 'oluştur', 'yeni fatura', 'fatura kes', 'fatura kesme', 'fatura kesmek', 'fatura keserim', 'fatura nasil kesilir', 'fatura nasıl kesilir', 'fatura nasil keserim', 'fatura nasıl keserim', 'fatura olustur', 'fatura oluştur'],
    steps: [
      'Muhasebe modülünde Faturalar ekranını açın.',
      'Fatura Oluştur butonuna basın.',
      'Müşteri, fatura tarihi ve vade tarihini seçin.',
      'KALEM EKLE ile mal/hizmet satırlarını girin (miktar, birim, fiyat, KDV).',
      'FATURA OLUŞTUR VE KAYDET ile kaydı tamamlayın.',
    ],
    hint: 'Oluşturulan fatura listeden Görüntüle ile açılabilir; PDF İndir ve Yazdır kullanılabilir.',
  },
  {
    id: 'invoice-pdf',
    section: 'accounting',
    title: 'Fatura PDF nasıl indirilir?',
    keywords: ['pdf', 'indir', 'yazdir', 'yazdır', 'fatura', 'onizle', 'önizle'],
    steps: [
      'Muhasebe > Faturalar listesinden faturayı bulun.',
      'Görüntüle butonu ile fatura detayını açın.',
      'PDF İndir butonuna basın.',
      'İsterseniz Yazdır ile doğrudan yazıcıya gönderebilirsiniz.',
    ],
    hint: 'PDF hazırlanırken kısa bir bekleme mesajı görünebilir.',
  },
  {
    id: 'irsaliye-create',
    section: 'accounting',
    title: 'İrsaliye nasıl oluşturulur?',
    keywords: ['irsaliye', 'sevk', 'teslim', 'sevkiyat', 'mal cikis', 'mal çıkış', 'irsaliye olustur', 'irsaliye oluştur', 'irsaliye kes', 'irsaliye nasil', 'irsaliye nasıl'],
    steps: [
      'Muhasebe modülünde İrsaliyeler ekranını açın.',
      'İrsaliye Oluştur butonuna basın.',
      'Müşteri, düzenleme tarihi ve teslimat bilgilerini girin.',
      'KALEM EKLE ile sevk edilecek mal/hizmet satırlarını girin (miktar ve birim).',
      'İRSALİYE OLUŞTUR ile kaydı tamamlayın.',
    ],
    hint: 'Oluşturulan irsaliye listeden Görüntüle ile açılabilir; PDF İndir ve Yazdır kullanılabilir. Durum sütunundan Taslak, Sevk Edildi, Teslim Edildi veya İptal seçilebilir. Faturaya Çevir ile satış faturası oluşturulabilir.',
  },
  {
    id: 'irsaliye-to-invoice',
    section: 'accounting',
    title: 'İrsaliye nasıl faturaya çevrilir?',
    keywords: ['irsaliye', 'faturaya cevir', 'faturaya çevir', 'satış faturası', 'dönüştür', 'donustur', 'cevir', 'çevir'],
    steps: [
      'Muhasebe modülünde İrsaliyeler ekranını açın.',
      'Faturaya çevirmek istediğiniz irsaliyede Faturaya Çevir butonuna basın.',
      'Kalemler için birim fiyat, iskonto ve KDV bilgilerini girin.',
      'Fatura ve vade tarihini kontrol edin.',
      'SATIŞ FATURASI OLUŞTUR ile işlemi tamamlayın.',
    ],
    hint: 'Dönüştürülen irsaliyenin Fatura sütununda fatura numarası görünür. İptal edilmiş veya zaten faturalanmış irsaliyeler dönüştürülemez.',
  },
  {
    id: 'expense-create',
    section: 'accounting',
    title: 'Gider nasıl eklenir?',
    keywords: ['gider', 'masraf', 'muhasebe', 'ekle', 'kaydet', 'harcama'],
    steps: [
      'Muhasebe modülünde Giderler ekranına girin.',
      'Gider Ekle butonunu seçin.',
      'Açıklama, tutar, kategori, tarih ve not alanlarını doldurun.',
      'Gideri Kaydet ile kaydı tamamlayın.',
    ],
    hint: 'Kategoriler: Genel, Kira, Fatura, Maaş, Hammadde, Lojistik, Pazarlama, Diğer.',
  },
  {
    id: 'customer-balances',
    section: 'accounting',
    title: 'Müşteri bakiyesi nereden görülür?',
    keywords: ['bakiye', 'cari', 'musteri', 'müşteri', 'alacak', 'borc', 'borç', 'tahsilat'],
    steps: [
      'Muhasebe modülünde Müşteri Bakiyeleri ekranını açın.',
      'Cari ara alanı ile müşteri arayın.',
      'Tabloda bakiye, toplam sipariş ve toplam alış sütunlarını inceleyin.',
    ],
    hint: 'Muhasebe ana ekranındaki Bakiyeler kısayol butonu da aynı bölüme gider.',
  },
  {
    id: 'accounting-reports',
    section: 'accounting',
    title: 'Finansal raporlar nerede?',
    keywords: ['rapor', 'finansal', 'gelir', 'gider', 'kar', 'aylik', 'aylık', 'ozet', 'özet'],
    steps: [
      'Muhasebe modülünde Finansal Raporlar ekranına gidin.',
      'Gelir ve Gider grafiğini inceleyin.',
      'Aylık Özet bölümünde aylık gelir, gider ve net kar değerlerini görün.',
    ],
    hint: 'Rapor ekranı genel finansal durumu hızlıca kontrol etmek içindir.',
  },

  // --- SATIŞ ---
  {
    id: 'customer-create',
    section: 'sales',
    title: 'Müşteri nasıl eklenir?',
    keywords: ['musteri', 'müşteri', 'cari', 'ekle', 'olustur', 'oluştur', 'kayit', 'kayıt', 'satis musteri'],
    steps: [
      'Satış modülünde Müşteriler ekranını açın.',
      'Müşteri Ekle butonuna basın.',
      'Müşteri adı, iletişim ve firma bilgilerini doldurun.',
      'Kaydet ile müşteriyi listeye ekleyin.',
    ],
    hint: 'Müşteri eklendikten sonra sipariş, fatura ve bakiye ekranlarında seçilebilir.',
  },
  {
    id: 'product-create',
    section: 'sales',
    title: 'Ürün nasıl eklenir?',
    keywords: ['urun', 'ürün', 'stok karti', 'stok kartı', 'ekle', 'olustur', 'oluştur', 'fiyat', 'sku'],
    steps: [
      'Satış modülünde Ürünler ekranını açın.',
      'Ürün Ekle butonuna basın.',
      'Ürün adı, SKU, kategori, stok ve fiyat bilgilerini girin.',
      'Kaydettikten sonra ürün sipariş ve fatura kalemlerinde seçilebilir.',
    ],
    hint: 'Ürün arama kutusu ile SKU veya ada göre hızlı arama yapabilirsiniz.',
  },
  {
    id: 'sales-orders-view',
    section: 'sales',
    title: 'Satış siparişleri nasıl izlenir?',
    keywords: ['satis siparis', 'satış sipariş', 'durum', 'onay', 'sevk', 'teslim', 'siparis listesi'],
    steps: [
      'Satış modülünde Siparişler ekranına gidin.',
      'Sipariş no ara alanı ile kayıt bulun.',
      'Durum sütunundan bekliyor, onaylandı, sevk edildi, teslim edildi veya iptal durumunu takip edin.',
    ],
    hint: 'Yeni satış kaydı açmak için Yeni Satış butonunu kullanın.',
  },

  // --- PAZARLAMA ---
  {
    id: 'campaign-create',
    section: 'marketing',
    title: 'Kampanya nasıl oluşturulur?',
    keywords: ['kampanya', 'pazarlama', 'butce', 'bütçe', 'olustur', 'oluştur', 'reklam'],
    steps: [
      'Pazarlama modülünde Kampanyalar ekranını açın.',
      'Kampanya Oluştur butonuna basın.',
      'Kampanya adı, bütçe, başlangıç ve bitiş tarihlerini girin.',
      'Kaydedin; kampanya kartları listede görünür.',
    ],
    hint: 'Kampanya durumu aktif, duraklatıldı veya tamamlandı olarak takip edilir.',
  },
  {
    id: 'customer-segments',
    section: 'marketing',
    title: 'Müşteri segmentleri nerede?',
    keywords: ['segment', 'vip', 'en iyi musteri', 'en iyi müşteri', 'harcama', 'aktif musteri'],
    steps: [
      'Pazarlama modülünde Müşteri Segmentleri ekranına gidin.',
      'Toplam, aktif, VIP ve yeni müşteri özet kartlarını inceleyin.',
      'Harcamaya Göre En İyi Müşteriler tablosundan detay görün.',
    ],
    hint: 'Segment ekranı satış performansına göre müşteri gruplarını analiz etmek içindir.',
  },
  {
    id: 'customer-notes',
    section: 'marketing',
    title: 'Müşteri notu nasıl eklenir?',
    keywords: ['not', 'crm', 'hatirlatma', 'hatırlatma', 'musteri notu', 'müşteri notu', 'iletisim', 'iletişim'],
    steps: [
      'Pazarlama modülünde Müşteri Notları ekranını açın.',
      'Not Ekle butonuna basın.',
      'Müşteriyi, not metnini ve isteğe bağlı hatırlatma tarihini girin.',
      'Kaydedin; not listede müşteri ve tarih bilgisiyle görünür.',
    ],
    hint: 'Hatırlatma tarihi girilen notlar Yaklaşan Hatırlatmalar ekranında da listelenir.',
  },
  {
    id: 'marketing-reminders',
    section: 'marketing',
    title: 'Yaklaşan hatırlatmalar nerede?',
    keywords: ['hatirlatma', 'hatırlatma', 'yaklasan', 'yaklaşan', 'takvim', 'crm'],
    steps: [
      'Pazarlama modülünde Yaklaşan Hatırlatmalar ekranına gidin.',
      'Müşteri adı, not ve hatırlatma tarihini kartlardan takip edin.',
      'Boş liste görürseniz yakın tarihte hatırlatma bulunmuyor demektir.',
    ],
    hint: 'Müşteri Notları ekranından yeni hatırlatmalar tanımlayabilirsiniz.',
  },

  // --- SİPARİŞLER ---
  {
    id: 'order-create',
    section: 'orders',
    title: 'Sipariş nasıl oluşturulur?',
    keywords: ['siparis', 'sipariş', 'kalem', 'musteri', 'müşteri', 'urun', 'ürün', 'olustur', 'oluştur', 'yeni siparis'],
    steps: [
      'Siparişler modülüne gidin ve Yeni Sipariş butonuna basın.',
      'Sipariş no, müşteri ve sipariş tarihini girin.',
      'Kalem Ekle ile ürünleri seçin; miktar ve birim fiyatları doldurun.',
      'Kaydet ile siparişi oluşturun.',
    ],
    hint: 'Sipariş kaydı için önce müşteri ve ürün kartlarının tanımlı olması gerekir.',
  },
  {
    id: 'order-edit',
    section: 'orders',
    title: 'Sipariş nasıl düzenlenir?',
    keywords: ['siparis duzenle', 'sipariş düzenle', 'guncelle', 'güncelle', 'degistir', 'değiştir'],
    steps: [
      'Siparişler listesinde ilgili satırda Düzenle butonuna basın.',
      'Müşteri, tarih, durum, kalemler veya not alanlarını güncelleyin.',
      'Kaydet ile değişiklikleri uygulayın.',
    ],
    hint: 'Sipariş Detay penceresinden durum güncellemesi de yapılabilir.',
  },
  {
    id: 'order-detail',
    section: 'orders',
    title: 'Sipariş detayı nereden görülür?',
    keywords: ['detay', 'siparis detay', 'sipariş detay', 'goruntule', 'görüntüle', 'kalemler'],
    steps: [
      'Siparişler listesinde Detay (göz) ikonuna tıklayın.',
      'Sipariş Detay penceresinde müşteri, tarihler, kalemler ve toplam tutarı inceleyin.',
      'Durum alanından sipariş durumunu güncelleyebilirsiniz.',
    ],
    hint: 'Durumlar: Bekliyor, İşleniyor, Tamamlandı, İptal.',
  },
  {
    id: 'order-delete',
    section: 'orders',
    title: 'Sipariş nasıl silinir?',
    keywords: ['siparis sil', 'sipariş sil', 'iptal kayit', 'kayit sil', 'kayıt sil'],
    steps: [
      'Siparişler listesinde Sil ikonuna basın.',
      'Onay penceresinde silme işlemini onaylayın.',
    ],
    hint: 'Silinen sipariş geri getirilemez; gerekirse durumu İptal olarak da bırakabilirsiniz.',
  },
  {
    id: 'order-filter',
    section: 'orders',
    title: 'Siparişler nasıl filtrelenir?',
    keywords: ['filtre', 'ara', 'durum', 'bekliyor', 'isleniyor', 'işleniyor', 'tamamlandi', 'tamamlandı'],
    steps: [
      'Sipariş no veya müşteri ara kutusuna arama yazın.',
      'Durum filtresinden Bekliyor, İşleniyor, Tamamlandı veya İptal seçin.',
      'Üst özet çubuğundan toplam, bugünkü ve tutar istatistiklerini takip edin.',
    ],
    hint: 'Tüm Durumlar seçeneği ile filtreyi kaldırabilirsiniz.',
  },

  // --- ÜRETİM ---
  {
    id: 'production-order',
    section: 'production',
    title: 'Üretim emri nasıl oluşturulur?',
    keywords: ['uretim', 'üretim', 'emir', 'malzeme', 'olustur', 'oluştur', 'uretim emri'],
    steps: [
      'Üretim modülünde Emirler veya Üretim Emirleri ekranına gidin.',
      'Emir Oluştur butonuna basın.',
      'Ürün veya hammadde seçin, miktar ve başlangıç tarihini girin.',
      'Oluştur ile emri kaydedin.',
    ],
    hint: 'Emir oluşturmadan önce ürün/hammadde kartlarının tanımlı olması gerekir.',
  },
  {
    id: 'production-status',
    section: 'production',
    title: 'Üretim emri durumu nasıl güncellenir?',
    keywords: ['uretim durum', 'üretim durum', 'baslat', 'başlat', 'tamamla', 'iptal', 'islem', 'işlem'],
    steps: [
      'Üretim Emirleri listesinde ilgili emri bulun.',
      'Bekleyen emirlerde İşlemi Başlat butonunu kullanın.',
      'Devam eden emirlerde Tamamla veya İptal butonlarını kullanın.',
    ],
    hint: 'Durumlar: Bekliyor, Devam Ediyor, Tamamlandı, İptal Edildi.',
  },
  {
    id: 'material-usage',
    section: 'production',
    title: 'Malzeme kullanımı nereden görülür?',
    keywords: ['malzeme', 'tuketim', 'tüketim', 'hammadde kullanim', 'kullanım', 'uretim malzeme'],
    steps: [
      'Üretim modülünde Malzeme veya Malzeme Kullanımı ekranına gidin.',
      'Ürün adı, SKU, toplam miktar ve malzeme maliyeti sütunlarını inceleyin.',
    ],
    hint: 'Bu rapor tamamlanan ve maliyet girilmiş üretim emirlerinden oluşur.',
  },
  {
    id: 'cost-analysis',
    section: 'production',
    title: 'Maliyet analizi nerede?',
    keywords: ['maliyet', 'analiz', 'gunluk', 'günlük', 'uretim maliyet', 'üretim maliyet'],
    steps: [
      'Üretim modülünde Maliyet veya Maliyet Analizi ekranına gidin.',
      'Son 30 günlük günlük üretim maliyetlerini tablodan inceleyin.',
      'Emir sayısı, günlük maliyet ve ortalama emir maliyeti sütunlarını karşılaştırın.',
    ],
    hint: 'Üretim ana ekranındaki Maliyet Özeti kartı hızlı özet sunar.',
  },
  {
    id: 'efficiency-report',
    section: 'production',
    title: 'Verimlilik raporu nerede?',
    keywords: ['verimlilik', 'rapor', 'uretim suresi', 'üretim süresi', 'gun', 'gün', 'efficiency'],
    steps: [
      'Üretim modülünde Verimlilik ekranına gidin.',
      'Tamamlanan emirlerin üretim günü, maliyet ve miktar bilgilerini tablodan takip edin.',
    ],
    hint: 'Başlangıç ve bitiş tarihi girilmiş emirlerde üretim günü hesaplanır.',
  },

  // --- NAKLİYE ---
  {
    id: 'shipment-create',
    section: 'shipping',
    title: 'Sevkiyat nasıl oluşturulur?',
    keywords: ['sevkiyat', 'kargo', 'teslimat', 'nakliye', 'olustur', 'oluştur', 'gonderi', 'gönderi'],
    steps: [
      'Nakliye modülünde Sevkiyatlar ekranını açın.',
      'Sevkiyat Oluştur butonuna basın.',
      'Müşteri, sevkiyat tipi, takip no ve teslim bilgilerini girin.',
      'Kaydı tamamladıktan sonra listeden takip edin.',
    ],
    hint: 'Sevkiyat tipleri: Kargo, Ambar ve RYS. Tip bazlı filtre ekranları da vardır.',
  },
  {
    id: 'shipment-types',
    section: 'shipping',
    title: 'Sevkiyat türleri nasıl görülür?',
    keywords: ['kargo', 'ambar', 'rys', 'sevkiyat tur', 'sevkiyat tür', 'sevkiyat tipi', 'sevkiyat filtresi', 'filtre'],
    steps: [
      'Nakliye modülünde Cargo, Ambar veya RYS sevkiyat ekranlarına gidin.',
      'Her ekranda yalnızca o tipe ait kayıtlar listelenir.',
      'Tüm Sevkiyatlar ekranından genel arama yapabilirsiniz.',
    ],
    hint: 'Nakliye ana ekranındaki Sevkiyat Türleri özeti kargo, ambar ve RYS adetlerini gösterir.',
  },
  {
    id: 'delayed-shipments',
    section: 'shipping',
    title: 'Geciken sevkiyatlar nereden izlenir?',
    keywords: ['geciken', 'gecikme', 'gecikmis', 'gecikmiş', 'risk', 'teslim tarihi'],
    steps: [
      'Nakliye modülünde Gecikenler veya Geciken Sevkiyatlar ekranına gidin.',
      'Gecikme günü, müşteri ve beklenen teslim tarihini kartlardan takip edin.',
      'Kayıt yoksa "Geciken Sevkiyat Yok" mesajı görünür.',
    ],
    hint: 'Nakliye ana ekranındaki Gecikenler kısayolu aynı listeye gider.',
  },
  {
    id: 'delivery-performance',
    section: 'shipping',
    title: 'Teslimat performansı nerede?',
    keywords: ['performans', 'teslim orani', 'teslim oranı', 'basari', 'başarı', 'ortalama teslim'],
    steps: [
      'Nakliye modülünde Performans veya Teslimat Performansı ekranına gidin.',
      'Firma, sevkiyat türü, toplam, teslim sayısı, başarı oranı ve ortalama teslim günü sütunlarını inceleyin.',
    ],
    hint: 'Performans ekranı lojistik verimliliğini karşılaştırmak içindir.',
  },

  // --- STOK ---
  {
    id: 'raw-material-create',
    section: 'stock',
    title: 'Yeni hammadde nasıl eklenir?',
    keywords: ['hammadde', 'yeni stok', 'stok karti', 'stok kartı', 'ekle', 'malzeme kart'],
    steps: [
      'Stok modülünde Hammaddeler sekmesine gidin.',
      'Yeni Hammadde butonuna basın.',
      'Kod, ad, kategori, birim, miktar, min. miktar, birim fiyat ve açıklama alanlarını doldurun.',
      'Kaydet ile hammadde kartını oluşturun.',
    ],
    hint: 'Birim seçenekleri: adet, kg, mt, L, paket.',
  },
  {
    id: 'stock-movement',
    section: 'stock',
    title: 'Stok giriş çıkış nasıl yapılır?',
    keywords: ['stok', 'giris', 'giriş', 'cikis', 'çıkış', 'hareket', 'depo', 'stok giris', 'stok cikis'],
    steps: [
      'Stok modülünde Stok Giriş/Çıkış butonuna basın.',
      'Malzeme ve depo seçin.',
      'İşlem tipini Stok Giriş veya Stok Çıkış olarak belirleyin.',
      'Miktar, birim fiyat, referans no ve açıklama girip Kaydet deyin.',
    ],
    hint: 'Stok Hareketleri sekmesinden geçmiş giriş/çıkış kayıtlarını görebilirsiniz.',
  },
  {
    id: 'warehouse-manage',
    section: 'stock',
    title: 'Depo nasıl yönetilir?',
    keywords: ['depo', 'warehouse', 'aktif depo', 'pasif', 'depo ekle'],
    steps: [
      'Stok modülünde Depolar sekmesine gidin.',
      'Depo listesinden mevcut depoları görüntüleyin veya yeni depo ekleyin.',
      'Depo durumunu Aktif veya Pasif olarak işaretleyin.',
    ],
    hint: 'Stok hareketi yaparken depo seçimi zorunludur.',
  },
  {
    id: 'category-manage',
    section: 'stock',
    title: 'Stok kategorisi nasıl eklenir?',
    keywords: ['kategori', 'ana kategori', 'alt kategori', 'siniflandirma', 'sınıflandırma'],
    steps: [
      'Stok modülünde Kategoriler sekmesine gidin.',
      'Yeni kategori ekleyin veya mevcut kategoriyi düzenleyin.',
      'Ana Kategori ve Alt Kategori yapısını kullanın.',
      'Hammadde kartı oluştururken bu kategorileri seçebilirsiniz.',
    ],
    hint: 'Kategoriler stok raporlarını düzenli tutmaya yardımcı olur.',
  },
  {
    id: 'critical-stock',
    section: 'stock',
    title: 'Kritik stok nasıl takip edilir?',
    keywords: ['kritik', 'min stok', 'minimum', 'uyari', 'uyarı', 'dusuk stok', 'düşük stok'],
    steps: [
      'Stok modülü ana özetinde Kritik Stok kartını inceleyin.',
      'Hammaddeler listesinde min. miktar altına düşen kalemleri kontrol edin.',
      'Gerekirse Stok Giriş işlemi ile stoğu tamamlayın.',
    ],
    hint: 'Portal ve Anasayfa ekranlarında da kritik stok uyarısı görünebilir.',
  },

  // --- İK ---
  {
    id: 'employee-create',
    section: 'hr',
    title: 'Personel nasıl eklenir?',
    keywords: ['personel', 'calisan', 'çalışan', 'ik', 'insan kaynaklari', 'insan kaynakları', 'ekle', 'isci', 'işçi'],
    steps: [
      'İnsan Kaynakları modülünde Personel sekmesine gidin.',
      'Yeni Personel butonunu seçin.',
      'Ad, soyad, departman, pozisyon, maaş ve başlangıç tarihi alanlarını doldurun.',
      'Kaydet ile personel kartını oluşturun.',
    ],
    hint: 'İzin ve devam takibi için önce personel kaydının oluşturulması gerekir.',
  },
  {
    id: 'leave-request',
    section: 'hr',
    title: 'İzin talebi nasıl açılır?',
    keywords: ['izin', 'yillik izin', 'yıllık izin', 'saglik izni', 'sağlık izni', 'talep', 'basvuru', 'başvuru'],
    steps: [
      'İK modülünde İzinler sekmesine gidin.',
      'İzin Talebi butonuna basın.',
      'Personel, izin türü, başlangıç/bitiş tarihi ve açıklama alanlarını doldurun.',
      'Gönder ile talebi kaydedin.',
    ],
    hint: 'İzin türleri: Yıllık İzin, Sağlık İzni, Diğer.',
  },
  {
    id: 'leave-approve',
    section: 'hr',
    title: 'İzin talebi nasıl onaylanır?',
    keywords: ['izin onay', 'izin red', 'onayla', 'reddet', 'bekleyen izin'],
    steps: [
      'İK modülünde İzinler sekmesine gidin.',
      'Bekleyen taleplerde onay (tik) veya red (çarpı) ikonuna basın.',
      'Onaylanan talepler durum sütununda Onaylı olarak görünür.',
    ],
    hint: 'Durumlar: Bekliyor, Onaylı, Reddedildi.',
  },
  {
    id: 'attendance',
    section: 'hr',
    title: 'Devam durumu nerede?',
    keywords: ['devam', 'yoklama', 'geldi', 'gelmedi', 'izinli', 'puantaj', 'attendance'],
    steps: [
      'İK modülünde Devam sekmesine gidin.',
      'Personel devam kayıtlarını tarih ve duruma göre inceleyin.',
      'Durumlar: Geldi, Gelmedi, İzinli.',
    ],
    hint: 'Devam kayıtları personel bazlı takip edilir.',
  },
  {
    id: 'hr-settings',
    section: 'hr',
    title: 'İK ayarları nereden yapılır?',
    keywords: ['ik ayar', 'sirket adi', 'şirket adı', 'para birimi', 'kdv', 'yetkiler', 'rol'],
    steps: [
      'İK modülünde Yetkiler sekmesine gidin.',
      'Şirket Adı, Para Birimi (TL/USD/EUR) ve KDV Oranı alanlarını güncelleyin.',
      'Ayarları Kaydet butonuna basın.',
    ],
    hint: 'Bu bölüm genel İK sistem ayarlarını içerir.',
  },

  // --- KULLANICILAR ---
  {
    id: 'user-create',
    section: 'users',
    title: 'Kullanıcı nasıl açılır?',
    keywords: ['kullanici', 'kullanıcı', 'yetki', 'rol', 'admin', 'hesap', 'ekle', 'yeni kullanici'],
    steps: [
      'Kullanıcı Yönetimi modülüne girin.',
      'Yeni Kullanıcı butonuna basın.',
      'Kullanıcı adı, e-posta, şifre ve rol seçin.',
      'Ad, soyad, telefon ve durum alanlarını doldurup Kaydet deyin.',
    ],
    hint: 'Yalnızca admin rolündeki kullanıcılar yeni kullanıcı ekleyebilir.',
  },
  {
    id: 'user-edit',
    section: 'users',
    title: 'Kullanıcı nasıl düzenlenir?',
    keywords: ['kullanici duzenle', 'kullanıcı düzenle', 'sifre degistir', 'şifre değiştir', 'rol degistir'],
    steps: [
      'Kullanıcılar listesinde Düzenle ikonuna basın.',
      'Rol, iletişim bilgileri veya durumu güncelleyin.',
      'Şifre değiştirmek için yeni şifre alanını doldurun.',
      'Kaydet ile güncellemeyi tamamlayın.',
    ],
    hint: 'Rol değişince kullanıcının modül yetkileri de otomatik güncellenir.',
  },
  {
    id: 'user-roles',
    section: 'users',
    title: 'Yetki ve rol nasıl verilir?',
    keywords: ['yetki', 'rol', 'muhasebe rol', 'satis rol', 'satış rol', 'personel rol', 'izinler'],
    steps: [
      'Kullanıcı eklerken veya düzenlerken Rol alanından uygun rolü seçin.',
      'Roller: Yönetici, Muhasebe, Satış, Pazarlama, Üretim, Nakliye, Stok, İK, Personel.',
      'Yönetici rolü tüm modüllere erişir; diğer roller sınırlı modül setine sahiptir.',
    ],
    hint: 'Rol seçildiğinde sistem o role ait varsayılan yetkileri otomatik atar.',
  },

  // --- MESAJLAR ---
  {
    id: 'send-message',
    section: 'messages',
    title: 'Yeni mesaj nasıl gönderilir?',
    keywords: ['mesaj gonder', 'mesaj gönder', 'yeni mesaj', 'alici', 'alıcı', 'konu', 'icerik', 'içerik'],
    steps: [
      'Mesajlar ekranında Yeni Mesaj butonuna basın.',
      'Alıcı seçin (bireysel kullanıcı veya HERKESE MESAJ GÖNDER).',
      'Konu ve içerik alanlarını doldurun.',
      'Gönder ile mesajı iletin.',
    ],
    hint: 'Admin kullanıcılar tüm birimlere toplu mesaj gönderebilir.',
  },
  {
    id: 'message-inbox',
    section: 'messages',
    title: 'Gelen mesajlar nasıl okunur?',
    keywords: ['gelen kutusu', 'inbox', 'okundu', 'mesaj oku', 'gelen mesaj'],
    steps: [
      'Mesajlar ekranında Gelen Kutusu sekmesini açın.',
      'Listeden bir mesaja tıklayın; sağ panelde içerik görünür.',
      'Mesaj açıldığında okundu olarak işaretlenir.',
    ],
    hint: 'Mesajlarda ara kutusu ile konu veya gönderene göre arama yapabilirsiniz.',
  },
  {
    id: 'message-delete',
    section: 'messages',
    title: 'Mesaj nasıl silinir?',
    keywords: ['mesaj sil', 'cop', 'çöp', 'kaldir', 'kaldır'],
    steps: [
      'Mesaj detayını açın.',
      'Mesajı Sil butonuna basın.',
      'Onay penceresinde silme işlemini tamamlayın.',
    ],
    hint: 'Gönderilenler sekmesinden giden mesajları da görüntüleyebilirsiniz.',
  },
  {
    id: 'message-usage',
    section: 'messages',
    title: 'Mesajlar ve bildirimler nasıl kullanılır?',
    keywords: ['mesaj', 'bildirim', 'ileti', 'konusma', 'konuşma', 'zil'],
    steps: [
      'Mesajlar ekranından gelen/giden kutularını kullanın.',
      'Üst bardaki zil ikonundan sistem bildirimlerini takip edin.',
      'Bildirime tıklayarak ilgili modül kaydına gidebilirsiniz.',
    ],
    hint: 'Okunmamış bildirimler zil ikonunda sayı ile gösterilir.',
  },

  // --- PROFİL ---
  {
    id: 'profile-update',
    section: 'profile',
    title: 'Profil bilgileri nasıl güncellenir?',
    keywords: ['profil', 'e-posta', 'eposta', 'email', 'bilgi guncelle', 'bilgi güncelle'],
    steps: [
      'Sağ üst menüden Profil ekranına gidin.',
      'Profil Bilgileri bölümünde e-posta adresinizi güncelleyin.',
      'Değişiklikleri Kaydet butonuna basın.',
    ],
    hint: 'Kullanıcı adı güvenlik nedeniyle değiştirilemez.',
  },
  {
    id: 'password-change',
    section: 'profile',
    title: 'Şifre nasıl değiştirilir?',
    keywords: ['sifre', 'şifre', 'parola', 'degistir', 'değiştir', 'yeni sifre'],
    steps: [
      'Profil ekranında Şifre Değiştir bölümüne gidin.',
      'Yeni şifrenizi iki kez girin (en az 6 karakter).',
      'Şifreyi Güncelle butonuna basın.',
    ],
    hint: 'Şifreler eşleşmiyorsa sistem uyarı verir.',
  },
  {
    id: 'company-profile',
    section: 'profile',
    title: 'Firma bilgileri nasıl güncellenir?',
    keywords: ['firma', 'vergi', 'vergi dairesi', 'vergi no', 'adres', 'yetkili', 'sirket', 'şirket'],
    steps: [
      'Profil ekranında Firma Bilgileri bölümünü açın.',
      'Firma adı, yetkili, telefon, e-posta, vergi dairesi, vergi no ve adres alanlarını doldurun.',
      'Firma Bilgilerini Kaydet butonuna basın.',
    ],
    hint: 'Demo hesapta firma bilgileri değiştirilemez.',
  },
];

const ROUTE_SUGGESTIONS = {
  portal: ['Modüllere nasıl geçilir?', 'Lisans nasıl satın alınır?', 'Demo sürüm sınırı nedir?'],
  dashboard: ['Ana panel ne gösterir?', 'Bildirimler nasıl okunur?', 'Modüllere nasıl geçilir?'],
  accounting: ['Fatura nasıl oluşturulur?', 'İrsaliye nasıl oluşturulur?', 'Gider nasıl eklenir?', 'Müşteri bakiyesi nereden görülür?'],
  sales: ['Müşteri nasıl eklenir?', 'Ürün nasıl eklenir?', 'Satış siparişleri nasıl izlenir?'],
  marketing: ['Kampanya nasıl oluşturulur?', 'Müşteri segmentleri nerede?', 'Yaklaşan hatırlatmalar nerede?'],
  orders: ['Sipariş nasıl oluşturulur?', 'Sipariş detayı nereden görülür?', 'Sipariş nasıl düzenlenir?'],
  production: ['Üretim emri nasıl oluşturulur?', 'Malzeme kullanımı nereden görülür?', 'Verimlilik raporu nerede?'],
  shipping: ['Sevkiyat nasıl oluşturulur?', 'Geciken sevkiyatlar nereden izlenir?', 'Teslimat performansı nerede?'],
  stock: ['Stok giriş çıkış nasıl yapılır?', 'Yeni hammadde nasıl eklenir?', 'Kritik stok nasıl takip edilir?'],
  hr: ['Personel nasıl eklenir?', 'İzin talebi nasıl açılır?', 'Devam durumu nerede?'],
  users: ['Kullanıcı nasıl açılır?', 'Yetki ve rol nasıl verilir?', 'Kullanıcı nasıl düzenlenir?'],
  messages: ['Yeni mesaj nasıl gönderilir?', 'Gelen mesajlar nasıl okunur?', 'Bildirimler nasıl okunur?'],
  profile: ['Profil bilgileri nasıl güncellenir?', 'Şifre nasıl değiştirilir?', 'Firma bilgileri nasıl güncellenir?'],
  generic: ['Sipariş nasıl oluşturulur?', 'Fatura nasıl oluşturulur?', 'Modüllere nasıl geçilir?'],
};

const FALLBACK_RESPONSES = {
  portal: 'Portal ekranından modüllere geçilir ve lisans işlemleri yapılır. Örnek: "Modüllere nasıl geçilir?" veya "Lisans nasıl satın alınır?"',
  dashboard: 'Anasayfa genel KPI, grafik ve aktivite özetlerini gösterir. Örnek: "Ana panel ne gösterir?"',
  accounting: 'Muhasebe: Faturalar, İrsaliyeler, Giderler, Finansal Raporlar, Müşteri Bakiyeleri. Örnek: "Fatura nasıl oluşturulur?"',
  sales: 'Satış: Müşteriler, Ürünler, Satış siparişleri. Örnek: "Müşteri nasıl eklenir?"',
  marketing: 'Pazarlama: Kampanyalar, segmentler, müşteri notları, hatırlatmalar. Örnek: "Kampanya nasıl oluşturulur?"',
  orders: 'Siparişler: oluşturma, düzenleme, detay, durum ve filtreleme. Örnek: "Sipariş nasıl oluşturulur?"',
  stock: 'Stok: hammadde kartı, giriş/çıkış, depo, kategori, kritik stok. Örnek: "Stok giriş çıkış nasıl yapılır?"',
  production: 'Üretim: emir, durum, malzeme, maliyet, verimlilik. Örnek: "Üretim emri nasıl oluşturulur?"',
  shipping: 'Nakliye: sevkiyat, tür filtreleri, gecikenler, performans. Örnek: "Sevkiyat nasıl oluşturulur?"',
  hr: 'İK: personel, izin, devam, sistem ayarları. Örnek: "Personel nasıl eklenir?"',
  users: 'Kullanıcı yönetimi: ekleme, düzenleme, rol/yetki. Örnek: "Kullanıcı nasıl açılır?"',
  messages: 'Mesajlar: gönderme, gelen kutusu, silme; bildirimler zil ikonundan. Örnek: "Yeni mesaj nasıl gönderilir?"',
  profile: 'Profil: e-posta, şifre ve firma bilgileri. Örnek: "Şifre nasıl değiştirilir?"',
  generic: 'Soruyu modül adı ve yapmak istediğiniz işlemle birlikte yazın. Örnek: "Stok giriş çıkış nasıl yapılır?"',
};

const MODULE_HINTS = {
  accounting: ['fatura', 'irsaliye', 'sevk', 'gider', 'masraf', 'muhasebe', 'cari', 'tahsilat', 'bakiye', 'pdf'],
  shipping: ['sevkiyat', 'kargo', 'nakliye', 'teslimat', 'gonderi', 'gönderi', 'ambar'],
  orders: ['siparis', 'sipariş'],
  sales: ['musteri', 'müşteri', 'urun', 'ürün', 'satis', 'satış'],
  stock: ['stok', 'hammadde', 'depo'],
  production: ['uretim', 'üretim', 'emir'],
  hr: ['personel', 'izin', 'devam', 'ik'],
  users: ['kullanici', 'kullanıcı', 'rol', 'yetki'],
  messages: ['mesaj', 'bildirim'],
  marketing: ['kampanya', 'segment', 'crm'],
};

const getQuestionTokens = (normalizedQuestion = '') =>
  normalizedQuestion.split(' ').filter(Boolean);

const keywordMatchesQuestion = (normalizedQuestion, normalizedKeyword) => {
  if (!normalizedKeyword) {
    return false;
  }

  if (normalizedKeyword.includes(' ')) {
    return normalizedQuestion.includes(normalizedKeyword);
  }

  const tokens = getQuestionTokens(normalizedQuestion);

  if (normalizedKeyword.length <= 3) {
    return tokens.includes(normalizedKeyword);
  }

  return tokens.some((token) => token === normalizedKeyword || token.includes(normalizedKeyword));
};

const getModuleIntentBoost = (topicSection, normalizedQuestion) => {
  const hints = MODULE_HINTS[topicSection] || [];
  const hasIntent = hints.some((hint) => keywordMatchesQuestion(normalizedQuestion, normalizeText(hint)));

  return hasIntent ? 6 : 0;
};

const normalizeText = (value = '') =>
  String(value)
    .toLocaleLowerCase('tr-TR')
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ı/g, 'i')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c')
    .replace(/[^a-z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const getSectionFromPath = (pathname = '') => {
  if (!pathname || pathname === '/') return 'generic';

  if (pathname.startsWith('/portal')) return 'portal';
  if (pathname.startsWith('/dashboard')) return 'dashboard';
  if (pathname.startsWith('/accounting')) return 'accounting';
  if (pathname.startsWith('/sales')) return 'sales';
  if (pathname.startsWith('/marketing')) return 'marketing';
  if (pathname.startsWith('/orders')) return 'orders';
  if (pathname.startsWith('/stock')) return 'stock';
  if (pathname.startsWith('/production')) return 'production';
  if (pathname.startsWith('/shipping')) return 'shipping';
  if (pathname.startsWith('/hr')) return 'hr';
  if (pathname.startsWith('/users')) return 'users';
  if (pathname.startsWith('/messages')) return 'messages';
  if (pathname.startsWith('/profile')) return 'profile';

  return 'generic';
};

const buildTopicResponse = (topic) => ({
  title: topic.title,
  steps: topic.steps,
  hint: topic.hint,
});

const scoreTopic = (topic, normalizedQuestion, section) => {
  let score = 0;

  topic.keywords.forEach((keyword) => {
    const normalizedKeyword = normalizeText(keyword);
    if (!normalizedKeyword) return;

    if (keywordMatchesQuestion(normalizedQuestion, normalizedKeyword)) {
      score += normalizedKeyword.includes(' ') ? 4 : 2;
    }
  });

  const titleWords = normalizeText(topic.title)
    .split(' ')
    .filter((word) => word.length > 2);

  titleWords.forEach((word) => {
    if (keywordMatchesQuestion(normalizedQuestion, word)) {
      score += 1;
    }
  });

  score += getModuleIntentBoost(topic.section, normalizedQuestion);

  if (topic.section === section && score > 0) {
    score += 2;
  }

  return score;
};

const findBestTopic = (question = '', pathname = '') => {
  const normalizedQuestion = normalizeText(question);
  const section = getSectionFromPath(pathname);

  if (!normalizedQuestion) {
    return null;
  }

  let bestTopic = null;
  let bestScore = 0;

  HELP_TOPICS.forEach((topic) => {
    const totalScore = scoreTopic(topic, normalizedQuestion, section);

    if (totalScore > bestScore) {
      bestTopic = topic;
      bestScore = totalScore;
    }
  });

  return bestScore > 0 ? bestTopic : null;
};

export const getSuggestedQuestions = (pathname = '') => {
  const section = getSectionFromPath(pathname);
  return ROUTE_SUGGESTIONS[section] || ROUTE_SUGGESTIONS.generic;
};

export const getWelcomeResponse = (pathname = '') => {
  const section = getSectionFromPath(pathname);
  const suggestions = getSuggestedQuestions(pathname).slice(0, 3);

  return {
    title: 'ROYSİS Yardım Robotu',
    steps: [
      'Yapmak istediğiniz işlemi Türkçe olarak yazabilirsiniz.',
      'Size bulunduğunuz modüle göre adım adım yol göstereceğim.',
      suggestions.length
        ? `Örnek sorular: ${suggestions.join(' • ')}`
        : 'Örnek: "Fatura nasıl oluşturulur?" veya "Sipariş nasıl oluşturulur?"',
    ],
    hint: FALLBACK_RESPONSES[section] || FALLBACK_RESPONSES.generic,
  };
};

export const getHelpResponse = (question = '', pathname = '') => {
  const section = getSectionFromPath(pathname);
  const bestTopic = findBestTopic(question, pathname);

  if (!normalizeText(question).trim()) {
    return getWelcomeResponse(pathname);
  }

  if (bestTopic) {
    return buildTopicResponse(bestTopic);
  }

  return {
    title: 'Bu konuda yardımcı olabilirim',
    steps: [
      'Soruyu biraz daha net yazın; modül adını da ekleyin.',
      'Örnek: "Nakliye modülünde geciken sevkiyatları nereden görürüm?"',
      'Aşağıdaki hızlı sorulardan birini de seçebilirsiniz.',
    ],
    hint: FALLBACK_RESPONSES[section] || FALLBACK_RESPONSES.generic,
  };
};
